const features = [
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '支持1080P与4K超清画质，杜比音效加持，影院级视听体验尽在掌握。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '秒开播放',
    desc: '全球CDN加速节点覆盖，点击即播无需等待，告别缓冲卡顿烦恼。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '无广告体验',
    desc: '纯净观影环境，全程无贴片广告、无弹窗打扰，沉浸式看片不被打断。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '热播剧集实时同步，院线下线即日上线，追剧日历提醒不错过任何更新。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步',
    desc: '手机、平板、电脑、电视全平台覆盖，播放记录云端同步，随时随地接着看。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">为什么选择大师兄影视</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">我们用心打磨每一个观影细节，只为给你最好的体验。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl p-6 bg-background-100 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-xl text-primary-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-bold font-heading text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}